export const typeUser = {
    admin: 'admin',
    pharmacist: 'pharmacist',
    employee: 'employee'
}
